import React, { useMemo } from 'react';
const BILL_IMAGE = 'https://cdn.magicpatterns.com/uploads/vwByjRLk8agt5cTFa2CQUN/Screenshot_2026-02-10_at_5.46.21_PM.png';
interface Bill {
  id: number;
  left: number;
  width: number;
  duration: number;
  delay: number;
  startRotation: number;
  opacity: number;
  swayAmount: number;
  animationType: number;
}
export function FallingMoney() {
  const bills = useMemo<Bill[]>(() => {
    return Array.from({
      length: 30
    }).map((_, i) => ({
      id: i,
      left: Math.random() * 110 - 5,
      width: 80 + Math.random() * 100,
      duration: 6 + Math.random() * 12,
      delay: Math.random() * 8,
      startRotation: Math.random() * 360,
      opacity: 0.12 + Math.random() * 0.18,
      swayAmount: 40 + Math.random() * 100,
      animationType: Math.floor(Math.random() * 4)
    }));
  }, []);
  return <div className="fixed inset-0 pointer-events-none overflow-hidden" style={{
    zIndex: 0
  }} aria-hidden="true" data-id="element-29">
      <style data-id="element-30">
        {`
          @keyframes billFall0 {
            0% {
              transform: translateY(-15vh) translateX(0px) rotate(0deg) scale(1);
              opacity: 0;
            }
            5% { opacity: var(--bill-opacity); }
            25% {
              transform: translateY(22vh) translateX(var(--sway)) rotate(120deg) scale(1.05);
            }
            50% {
              transform: translateY(48vh) translateX(calc(var(--sway) * -0.6)) rotate(200deg) scale(0.95);
            }
            75% {
              transform: translateY(74vh) translateX(var(--sway)) rotate(310deg) scale(1.02);
            }
            95% { opacity: var(--bill-opacity); }
            100% {
              transform: translateY(115vh) translateX(calc(var(--sway) * -0.3)) rotate(400deg) scale(1);
              opacity: 0;
            }
          }

          @keyframes billFall1 {
            0% {
              transform: translateY(-12vh) translateX(0px) rotate(0deg) rotateY(0deg) scale(1);
              opacity: 0;
            }
            5% { opacity: var(--bill-opacity); }
            20% {
              transform: translateY(18vh) translateX(calc(var(--sway) * -1)) rotate(-80deg) rotateY(90deg) scale(0.9);
            }
            40% {
              transform: translateY(38vh) translateX(calc(var(--sway) * 0.7)) rotate(-160deg) rotateY(180deg) scale(1.1);
            }
            60% {
              transform: translateY(58vh) translateX(calc(var(--sway) * -0.5)) rotate(-260deg) rotateY(270deg) scale(0.95);
            }
            80% {
              transform: translateY(80vh) translateX(calc(var(--sway) * 0.4)) rotate(-340deg) rotateY(360deg) scale(1.05);
            }
            95% { opacity: var(--bill-opacity); }
            100% {
              transform: translateY(115vh) translateX(0px) rotate(-400deg) rotateY(450deg) scale(1);
              opacity: 0;
            }
          }

          @keyframes billFall2 {
            0% {
              transform: translateY(-18vh) translateX(0px) rotate(0deg) scale(0.9);
              opacity: 0;
            }
            5% { opacity: var(--bill-opacity); }
            15% {
              transform: translateY(10vh) translateX(calc(var(--sway) * 1.2)) rotate(60deg) scale(1.1);
            }
            35% {
              transform: translateY(32vh) translateX(calc(var(--sway) * -0.8)) rotate(150deg) scale(0.85);
            }
            55% {
              transform: translateY(55vh) translateX(calc(var(--sway) * 1.5)) rotate(240deg) scale(1.15);
            }
            75% {
              transform: translateY(76vh) translateX(calc(var(--sway) * -1.1)) rotate(330deg) scale(0.9);
            }
            95% { opacity: var(--bill-opacity); }
            100% {
              transform: translateY(115vh) translateX(calc(var(--sway) * 0.5)) rotate(420deg) scale(1);
              opacity: 0;
            }
          }

          @keyframes billFall3 {
            0% {
              transform: translateY(-10vh) translateX(0px) rotate(0deg) rotateX(0deg) scale(1);
              opacity: 0;
            }
            5% { opacity: var(--bill-opacity); }
            30% {
              transform: translateY(28vh) translateX(calc(var(--sway) * 0.8)) rotate(100deg) rotateX(180deg) scale(1.08);
            }
            50% {
              transform: translateY(50vh) translateX(calc(var(--sway) * -1.3)) rotate(180deg) rotateX(360deg) scale(0.88);
            }
            70% {
              transform: translateY(70vh) translateX(calc(var(--sway) * 0.6)) rotate(280deg) rotateX(540deg) scale(1.12);
            }
            95% { opacity: var(--bill-opacity); }
            100% {
              transform: translateY(115vh) translateX(calc(var(--sway) * -0.4)) rotate(380deg) rotateX(720deg) scale(1);
              opacity: 0;
            }
          }
        `}
      </style>
      {bills.map(bill => {
      const animName = `billFall${bill.animationType}`;
      return <img key={bill.id} src={BILL_IMAGE} alt="" draggable={false} style={{
        position: 'absolute',
        top: 0,
        left: `${bill.left}%`,
        width: `${bill.width}px`,
        height: 'auto',
        animationName: animName,
        animationDuration: `${bill.duration}s`,
        animationDelay: `${bill.delay}s`,
        animationTimingFunction: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
        animationIterationCount: 'infinite',
        animationFillMode: 'backwards',
        opacity: 0,
        ['--bill-opacity' as string]: bill.opacity,
        ['--sway' as string]: `${bill.swayAmount}px`,
        filter: 'drop-shadow(0 4px 12px rgba(61, 31, 46, 0.2))',
        willChange: 'transform, opacity'
      }} data-id="element-31" />;
    })}
    </div>;
}